module.exports = __webpack_public_path__ + "static/img/fwzc_06.864fe70.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/fwzc_06.png
// module id = YIFL
// module chunks = 2